webpackJsonp([14],{

/***/ "./load-content-ajax.js":
/***/ (function(module, exports) {

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

window.aboundLoadContentAjax = function (containerEl, requestUrl) {
    if (!containerEl) return;

    return fetch(requestUrl, {
        method: 'get',
        credentials: "same-origin" // won't send cookies without this
    }).then(function (x) {
        return x.text();
    }).then(function (html) {
        containerEl.innerHTML = html;
        var scriptEls = [].concat(_toConsumableArray(containerEl.querySelectorAll('script')));

        // scripts aren't run by setting them in innerHTML, so need to run them by recreating them
        // need to execute scripts in order (in case some rely on others), so will wait for each to load to load next
        var processScripts = function processScripts() {
            if (!scriptEls.length) return;

            var nextScriptEl = scriptEls.shift();
            var dupeScriptEl = document.createElement('script');
            dupeScriptEl.onload = processScripts;
            if (nextScriptEl.src) dupeScriptEl.src = nextScriptEl.src;

            nextScriptEl.childNodes.forEach(function (childNode) {
                dupeScriptEl.appendChild(childNode.cloneNode());
            });

            containerEl.appendChild(dupeScriptEl);
        };

        processScripts();
    });
};

/***/ })

},["./load-content-ajax.js"]);


// WEBPACK FOOTER //
// scripts/load-content-ajax.d075e11b60a6b8e95314.js